import Request from "@services/request";
import { IGetAllFormData, IGetSingleFormData } from "./types";

const GetAll = async ({ query, page }: IGetAllFormData) =>
    await new Request().get<IReturnValue<Array<IGallery["get"]>>>("GALLERY", {
        params: {
            query,
            page,
        },
    });

const GetSingle = async ({ id }: IGetSingleFormData) =>
    await new Request().get<IReturnValue<IGalleryItem["get"]>>({
        base: "GALLERY_ITEM",
        params: {
            id,
        },
    });

const Create = async ({ file }: Partial<IGallery["post"]>) => {
    if (!file) return undefined;

    const formData = new FormData();

    formData.append("file", file);

    return await new Request().post<FormData, IReturnValue<any>>(
        "GALLERY_PHOTO",
        formData,
    );
};

const Edit = async ({
    id,
    title,
    products,
    categories,
    description,
}: IGalleryItem["put"]) =>
    await new Request().put<Omit<IGalleryItem["put"], "id">, IReturnValue<any>>(
        {
            base: "GALLERY_ITEM",
            params: {
                id,
            },
        },
        { title, products, categories, description },
    );

const Delete = async ({ id }: IGalleryItem["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "GALLERY_ITEM",
        params: {
            id,
        },
    });

const UploadFile = async ({ file }: { id: number; file: File }) => {
    const formData = new FormData();

    formData.append("file", file);

    return await new Request().post<
        FormData,
        IReturnValue<{
            url: string;
        }>
    >("GALLERY_FILE", formData);
};

// Main Object
const GalleryApis = {
    GetAll,
    GetSingle,
    Create,
    Edit,
    Delete,
    UploadFile,
};

export default GalleryApis;
